/* Aura Noire · orden de las capas superpuestas (ver assets/aura-overlays.css).
   1. Primero el consentimiento de cookies: mientras el banner de Shopify o su panel de preferencias están abiertos,
      el pop-up de Klaviyo espera (oculto, sin bloquear la página). Igual mientras el buscador está abierto.
      Al aceptar, rechazar o cerrar, el pop-up aparece. No se toca Klaviyo ni el consentimiento.
      Klaviyo cierra su pop-up con cualquier toque fuera de él, también en el banner de cookies (y entonces no lo vuelve
      a mostrar en un día). Si el cierre ocurre mientras el pop-up está en espera, se vuelve a abrir al terminar con las
      cookies (API pública de Klaviyo: _klOnsite.push(['openForm', id])). Si lo cierra el propio visitante, no se reabre.
   2. En el idioma principal (sin prefijo), el banner de Shopify enlaza la privacidad a /en/policies/... (404):
      se corrige a /policies/..., que es la página que existe. */
(function () {
  'use strict';
  if (window.__auraOverlays) return;
  window.__auraOverlays = true;

  var html = document.documentElement;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = (window.Shopify && window.Shopify.locale) || '';

  function shown(el) {
    if (!el) return false;
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function consentOpen() {
    return shown(document.getElementById('shopify-pc__banner')) || shown(document.getElementById('shopify-pc__prefs__dialog')) ||
      shown(document.querySelector('.shopify-pc__prefs__dialog'));
  }
  function searchOpen() {
    return !!document.querySelector('details-modal details[open] .search-modal, details-modal.header__search details[open]');
  }

  function fixPolicyLinks() {
    if (root !== '/' || !locale) return;
    var bad = '/' + locale + '/policies/';
    var links = document.querySelectorAll('#shopify-pc__banner a[href*="' + bad + '"], .shopify-pc__prefs__dialog a[href*="' + bad + '"], #shopify-pc__prefs a[href*="' + bad + '"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', links[i].getAttribute('href').replace(bad, '/policies/'));
    }
  }

  var queued = false, holding = false, holdEndedAt = 0, reopenForm = null;
  function update() {
    queued = false;
    var hold = consentOpen() || searchOpen();
    if (holding && !hold) {
      holdEndedAt = Date.now();
      if (reopenForm) {
        var id = reopenForm; reopenForm = null;
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', id]);
        }, 400);
      }
    }
    holding = hold;
    html.classList.toggle('an-hold-popups', hold);
    fixPolicyLinks();
  }
  // Cierre del pop-up provocado por el banner (en espera, o justo al pulsar Aceptar/Rechazar): se reabrirá después.
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'close' || !d.formId) return;
    if (holding || html.classList.contains('an-hold-popups') || Date.now() - holdEndedAt < 1500) {
      reopenForm = d.formId;
      if (!holding && !html.classList.contains('an-hold-popups')) {
        var id = reopenForm; reopenForm = null;
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', id]);
        }, 400);
      }
    }
  });
  function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }

  function start() {
    update();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'style', 'class', 'hidden', 'aria-hidden'] });
    document.addEventListener('visitorConsentCollected', queue);
    document.addEventListener('click', function () { setTimeout(queue, 50); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
